import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "className"],
  _excluded2 = ["children", "dataContentName", "modal", "title", "size", "className", "labels", "headerClassName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import i from "react-modal";
import { Button as b } from "../Button/Button.js";
import { RemoveScroll as M } from "react-remove-scroll";
import { c as a } from "../clsx-OuTLNxxd.js";
import { i as m } from "../checks-C6AyTTQ0.js";
const p = "Modal-module_overlay__G9Xr-",
  f = "Modal-module_overlay-after-open__4-R9O",
  h = "Modal-module_overlay-before-close__-xgix",
  B = "Modal-module_content__mFw-i",
  g = "Modal-module_content-big__uq-LF",
  v = "Modal-module_content-medium__8yQJF",
  C = "Modal-module_content-small__7khB1",
  F = "Modal-module_content-fullscreen__9dMPZ",
  w = "Modal-module_header__z5Uz2",
  x = "Modal-module_title__mfggV",
  N = "Modal-module_body__sJ1sU",
  P = "Modal-module_body-boxed__HMWGs",
  T = "Modal-module_body-wide__kVAFK",
  A = "Modal-module_body-content__yBsNI",
  S = "Modal-module_body-full__EiobP",
  O = "Modal-module_with-padding-bottom__phvrt",
  R = "Modal-module_with-padding-top__-Qpvh",
  q = "Modal-module_body-title__mHE2X",
  E = "Modal-module_modal-footer__z03TK",
  o = {
    overlay: p,
    overlayAfterOpen: f,
    overlayBeforeClose: h,
    content: B,
    contentBig: g,
    contentMedium: v,
    contentSmall: C,
    contentFullscreen: F,
    header: w,
    title: x,
    body: N,
    bodyBoxed: P,
    bodyWide: T,
    bodyContent: A,
    bodyFull: S,
    withPaddingBottom: O,
    withPaddingTop: R,
    bodyTitle: q,
    modalFooter: E
  },
  K = _ref => {
    let {
      className: e,
      variant: t = "wide",
      paddingBottom: l = !0,
      paddingTop: s = !0,
      removeScroll: d = !0,
      children: c
    } = _ref;
    return /* @__PURE__ */n(M, {
      enabled: d,
      className: a(e, {
        [o.body]: !0,
        [o.bodyWide]: t == "wide",
        [o.bodyBoxed]: t == "boxed",
        [o.bodyFull]: t == "full",
        [o.withPaddingTop]: s,
        [o.withPaddingBottom]: l
      }),
      children: c
    });
  },
  L = _ref2 => {
    let {
        children: e,
        className: t
      } = _ref2,
      l = _objectWithoutProperties(_ref2, _excluded);
    return /* @__PURE__ */n("div", _objectSpread(_objectSpread({}, l), {}, {
      className: a(o.bodyContent, t),
      children: e
    }));
  },
  Q = _ref3 => {
    let {
      children: e
    } = _ref3;
    return /* @__PURE__ */n("div", {
      className: o.bodyTitle,
      children: e
    });
  },
  U = _ref4 => {
    let {
      children: e,
      className: t
    } = _ref4;
    return /* @__PURE__ */n("footer", {
      className: a(o.modalFooter, t),
      children: e
    });
  },
  V = e => i.setAppElement(e),
  X = _ref5 => {
    let {
        children: e,
        dataContentName: t,
        modal: l,
        title: s,
        size: d = "big",
        className: c,
        labels: _ = {
          close: "Close"
        },
        headerClassName: u
      } = _ref5,
      y = _objectWithoutProperties(_ref5, _excluded2);
    return /* @__PURE__ */r(i, _objectSpread(_objectSpread({}, l), {}, {
      data: {
        "content-name": t || y["data-content-name"]
      },
      contentLabel: "modal",
      closeTimeoutMS: 300,
      overlayClassName: {
        base: o.overlay,
        afterOpen: o.overlayAfterOpen,
        beforeClose: o.overlayBeforeClose
      },
      className: a(o.content, {
        [o.contentBig]: d == "big",
        [o.contentMedium]: d == "medium",
        [o.contentSmall]: d == "small",
        [o.contentFullscreen]: d == "fullscreen"
      }, c),
      children: [(m(s) || m(l.onRequestClose)) && /* @__PURE__ */r("header", {
        className: a(o.header, u),
        children: [/* @__PURE__ */n("div", {
          className: o.title,
          children: s
        }), l.onRequestClose && /* @__PURE__ */n(b, {
          renderAs: "button",
          variant: "text",
          size: "regular",
          iconName: "close",
          dataContentPiece: "close-modal",
          onClick: l.onRequestClose,
          children: _.close
        })]
      }), e]
    }));
  };
export { X as Modal, K as ModalBody, L as ModalBodyContent, Q as ModalBodyTitle, U as ModalFooter, V as modalSetAppElement };